export default{
    loginendpoint:"https://chef.mybukka.com/api/v1/bukka/auth/custom/login",
    carddtlsendpoint:"https://chef.mybukka.com/api/v1/bukka/customer/card/",
    signupendpoint:"https://chef.mybukka.com/api/v1/bukka/auth/register",
    chefendpoint:"https://chef.mybukka.com/api/v1/bukka/chefs/",
    logo:"https://res.cloudinary.com/www-mybukka-com/image/upload/v1505151382/logo_m8ik1x.png",
    menupageBackground:'https://www.miami.com/wp-content/uploads/sites/2/2016/12/h-mcdonalds-Double-Quarter-Pounder-with-Cheese-Extra-Value-Meals.png',
    addcard:'https://chef.mybukka.com/api/v1/bukka/customer/cardDetails/',
    normalizedlogo:'https://res.cloudinary.com/www-mybukka-com/image/upload/v1513294716/logo-light_xnxon0_rzghhp.png',
    macdlogo:"https://www.mcdonalds.com/content/dam/usa/documents/mcdelivery/mcdelivery_new11.jpg",
    placeorderendpoint:"https://chef.mybukka.com/api/v1/bukka/transaction/incoming",
    applelogo:'https://res.cloudinary.com/www-mybukka-com/image/upload/v1508504845/c4c51cdd9a95bdb0c488ff0a013c865c_smq7g5.png',
    googleplaylogo:'https://res.cloudinary.com/www-mybukka-com/image/upload/v1508342712/appstore_bkvsi2.png',
    visa:"https://res.cloudinary.com/bukka/image/upload/v1500737722/app/visa.png",
    master:"https://res.cloudinary.com/bukka/image/upload/v1500737722/app/mastercard.png",
    verve:"https://res.cloudinary.com/bukka/image/upload/v1500737722/app/verve.png",
    order_history:"https://chef.mybukka.com/api/v1/bukka/customer/orders/",
    forgot_password:'https://chef.mybukka.com/api/v1/bukka/forgotPassword',
    African:'https://res.cloudinary.com/www-mybukka-com/image/upload/v1517495561/african_z3jqmb.jpg',
    Continental:'https://res.cloudinary.com/www-mybukka-com/image/upload/v1517495615/continental_sr7ftd.jpg',
    Vegetarian:'https://res.cloudinary.com/www-mybukka-com/image/upload/v1517495643/healthy_dvijen.jpg',
    'Home made': 'https://res.cloudinary.com/www-mybukka-com/image/upload/v1517495673/Homemade_ybpbma.jpg',
    Chinese: 'https://res.cloudinary.com/www-mybukka-com/image/upload/v1517495582/chinese_yzt2ur.jpg',
    'Finger food': 'https://res.cloudinary.com/www-mybukka-com/image/upload/v1517495705/Productimage---Small---Chops_tr9bck.jpg',
    Grills: 'https://res.cloudinary.com/www-mybukka-com/image/upload/v1517542876/andrew-itaga-145332_vstr4g.jpg',
    'Fast food': 'https://res.cloudinary.com/www-mybukka-com/image/upload/v1517936047/niklas-rhose-14304_iuneus.jpg',
    GMapApi:"https://maps.googleapis.com/maps/api/js?key=AIzaSyBjt71qZwbmnRSpiTNC9KELMVQqKT6tV_M=3.exp&libraries=geometry,drawing",
    smsApi:'https://chef.mybukka.com/api/v1/bukka/sms',
    edit_user: 'https://chef.mybukka.com/api/v1/bukka/customer/',
    mobileimage: 'https://res.cloudinary.com/www-mybukka-com/image/upload/v1517827796/mobile_diagonal_dakom9.png',
    newapplelogo: 'https://res.cloudinary.com/www-mybukka-com/image/upload/v1517827755/apple-logo_om689r.png',
    newandroidlogo: 'https://res.cloudinary.com/www-mybukka-com/image/upload/v1517827768/android_k6jvri.png',
    link:'https://mybukka.com/forgotPassword',
    origin:'https://mybukka.com',
    resetPassword:'https://chef.mybukka.com/api/v1/bukka/resetPassword',
    apikey:'iamnottellingyou',
    username:'iamnottellingyou',
    paystack: 'iamnottellingyou',
    checkBalance:'https://api.paystack.co/transaction/check_authorization',
    reauth:'https://api.paystack.co/transaction/request_reauthorization'
}

export const cuisineDescription={
    African:"Eat delicious authentic African recipes from restaurants around you.",
    Continental: "Eat delicious authentic European recipes from restaurants around you",
    Vegetarian: "Eat delicious healthy food like salad from restaurants around you.",
    'Home made': "Eat delicious authentic homemade food, from chefs who cook from home.",
    Chinese: "Eat delicious authentic Chinese recipes from restaurants around you.",
    Grills: "Eat delicious authentic grilled food from restaurants around you.",
    'Fast food': "Eat delicious food from fast food from restaurants around you.",
    'Finger food': "Eat delicious finger food from restaurants around you."
}
export const  mapStateToProps=(state)=>(state)


// WEBPACK FOOTER //
// ./src/util/ajax.js